export function removeAttributeWithoutValue() {
    document.querySelectorAll('.itemcardAttributesTable tr:has(td:nth-child(2):empty)').forEach(element => element.remove());
}